import { render, staticRenderFns } from "./hotelDirectMining.vue?vue&type=template&id=41043aa1&scoped=true"
import script from "./hotelDirectMining.vue?vue&type=script&lang=js"
export * from "./hotelDirectMining.vue?vue&type=script&lang=js"
import style0 from "./hotelDirectMining.vue?vue&type=style&index=0&id=41043aa1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41043aa1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41043aa1')) {
      api.createRecord('41043aa1', component.options)
    } else {
      api.reload('41043aa1', component.options)
    }
    module.hot.accept("./hotelDirectMining.vue?vue&type=template&id=41043aa1&scoped=true", function () {
      api.rerender('41043aa1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/directPurchaseSpecialPrice/directPurchassSpecialchild/hotelDirectMining.vue"
export default component.exports